 // スクリプトが重複して実行されるのを防ぐ
  if (!window.productMediaObserverInitialized) {
    window.productMediaObserverInitialized = true;

    // 即時実行関数でスコープを限定
    (() => {
      // IntersectionObserverのインスタンスを一度だけ生成
      const intersectionObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            // 一度表示された要素の監視は解除してパフォーマンスを最適化
            observer.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '0px 0px -10% 0px'
      });

      // 新しい要素を監視対象に追加する関数
      const observeElements = (container) => {
        // まだ監視されていない `.fade-in-on-scroll` 要素をすべて選択
        const targets = container.querySelectorAll('.fade-in-on-scroll:not(.is-observed)');
        targets.forEach(target => {
          target.classList.add('is-observed'); // 処理済みのマークとしてクラスを追加
          intersectionObserver.observe(target);
        });
      };

      // 1. 初回読み込み時に実行
      document.addEventListener('DOMContentLoaded', () => {
        observeElements(document.body);
      });

      // 2. DOMの変更を監視するMutationObserverをセットアップ
      // これがページ内遷移などで動的に追加された要素を検知する鍵
      const mutationObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          // 追加されたノード（要素）があれば、その中をスキャン
          if (mutation.addedNodes.length) {
            // DocumentFragmentやElementが追加された場合に対応
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                 observeElements(node);
              }
            });
          }
        }
      });

      // body全体の要素の追加・削除を監視開始
      mutationObserver.observe(document.body, {
        childList: true, // 子要素（直接の子）の変更を監視
        subtree: true    // すべての子孫要素の変更を監視
      });

    })();
  }